"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconProgrammingHoldCode = /*#__PURE__*/
function (_Icon) {
  _inherits(IconProgrammingHoldCode, _Icon);
  function IconProgrammingHoldCode(props) {
    var _this;
    _classCallCheck(this, IconProgrammingHoldCode);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconProgrammingHoldCode).call(this, props));
    _this.name = 'IconProgrammingHoldCode';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "programming-hold-code_svg__group0"
    }, _react2.default.createElement("path", {
      className: "programming-hold-code_svg__path0",
      d: "M12.661 22.424c-1.376 0-2.893-.527-5.405-1.399l-.034-.011c-.662-.23-1.395-.485-2.222-.764v.242c0 .552-.449 1-1 1H1c-.551 0-1-.448-1-1v-7c0-.552.449-1 1-1h3c.551 0 1 .448 1 1h2.5c1.775 0 3.164 1.017 3.993 1.625.158.116.445.326.549.375h3.457c.722 0 1.141.584 1.231 1.232l3.618-1.146a3.274 3.274 0 013.552 1.179.5.5 0 01-.177.745c-2.034 1.017-3.628 1.865-4.909 2.546-2.975 1.582-4.468 2.376-6.153 2.376zM5 19.195c1.007.338 1.878.64 2.584.886 2.485.863 3.854 1.338 5.063 1.338 1.461 0 2.788-.706 5.696-2.252 1.148-.61 2.561-1.362 4.324-2.252a2.28 2.28 0 00-1.386-.473c-.217 0-.432.031-.639.093L16.55 17.83c-.223.422-.6.662-1.05.662H10a.5.5 0 010-1h5.5c.208 0 .25-.394.25-.5s-.042-.5-.25-.5H12c-.321 0-.613-.214-1.097-.568-.779-.571-1.956-1.432-3.403-1.432H5v4.703zm-4 1.297h3v-7H1v7z"
    }), _react2.default.createElement("path", {
      className: "programming-hold-code_svg__path1",
      d: "M19.5 10.992a.5.5 0 01-.354-.854l3.646-3.646-3.646-3.646a.501.501 0 01.708-.708l4 4a.5.5 0 010 .708l-4 4a.5.5 0 01-.354.146z"
    }), _react2.default.createElement("path", {
      className: "programming-hold-code_svg__path2",
      d: "M11.5 10.992a.5.5 0 01-.354-.146l-4-4a.501.501 0 010-.708l4-4a.5.5 0 11.708.708L8.207 6.492l3.646 3.646a.5.5 0 01-.353.854z"
    }), _react2.default.createElement("path", {
      className: "programming-hold-code_svg__path3",
      d: "M14.5 11.492a.5.5 0 01-.488-.608l2-9a.504.504 0 01.597-.379.5.5 0 01.38.596l-2 9a.505.505 0 01-.489.391z"
    })));
    return _this;
  }
  return IconProgrammingHoldCode;
}(_Icon3.default);
exports.default = IconProgrammingHoldCode;